<div #zoomDiv class="jk-row-border">
  <h4 class="text-center text-blue-700">股票下單</h4>
  <div class="flex">
    <app-jkcombobox [styleDisplay]="'flex'" label="帳號" [(value)]="stktsSrv.newItem.TS002" [width]="'200px'"
      [items]="stkmbSrv().accountList">
    </app-jkcombobox>
    <app-jkdatefield label="委託日期" [(value)]="date" [showClearButton]="true" (valueChange)="onDateValueChange($event)">
    </app-jkdatefield>
  </div>
  <mat-tab-group #masterTabGroup (selectedTabChange)="onMasterTabChange($event)">
    <mat-tab #myTabGrid label="股票下單">
      <div class="jk-row-border" style="width: 350px">
        <div class="flex">
          <app-jkautocomplete label="商品代號" [showClearButton]="true" valueExpr="id" displayExpr="name"
            [itemList]="stkmaSrv.stockList" [(value)]="stockno">
          </app-jkautocomplete>
          <button class="jk-button-small" matSuffix mat-icon-button aria-label="open win" matTooltip="庫存"
            (click)="doOpenwinStock($event)">
            <mat-icon>more_vert</mat-icon>
          </button>
        </div>
        <app-jkbuttongroup matTooltip="分類" [items]="stktsSrv.StkTs006List" [(value)]="period" mat->
        </app-jkbuttongroup>
        <div>
          <app-jkedit [visible]="true" [label]="'委託價'" [required]="true" [(value)]="stktsSrv.newItem.TS009" [width]="80"
            [styleDisplay]="'flex'">
          </app-jkedit>
          <app-jkbuttongroup [title]="''" [items]="priceTypeList" [(value)]="priceType">
          </app-jkbuttongroup>
          <app-jkbuttongroup matTooltip="特別交易類型" [items]="stktsSrv.specialTradeTypeList"
            [(value)]="stktsSrv.specialTradeType">
          </app-jkbuttongroup>
        </div>
        <div class="flex">
          <app-jkbuttongroup matTooltip="買賣" [items]="buysaleList" [(value)]="stktsSrv.buysale"
            >
            <!-- (valueChange)="stktsSrv.onBuySaleValueChange($event)" -->
          </app-jkbuttongroup>
          <app-jknumberedit [visible]="true" [label]="qtyLabel" [required]="true" [(value)]="stktsSrv.qty" width="60"
            [styleDisplay]="'flex'">
          </app-jknumberedit>
        </div>
        <div>現價:{{stklg.LG010}} 開盤價:{{stklg.LG007}} 最高價:{{stklg.LG008}} 最低價:{{stklg.LG009}} </div>
        <div>報價日期:{{stklg.LG001}} 布林上軌:{{stklg.LG014}} 布林下軌:{{stklg.LG015}} 中軌:{{stklg.LG017}} 更新時間{{stklg.LG012 |
          date:'yyyy/MM/dd hh:mm:ss'}}</div>
        @if(stkmq.MQ001!==''){
        <div class="flex">
          即時庫存:{{stkmq.MQ018}} 商品代號:{{stkmq.MQ001}} 股數:昨日庫存:{{stkmq.MQ010}} 今日委買:{{stkmq.MQ011}} 今日委賣:{{stkmq.MQ012}}
          今日買進成交:{{stkmq.MQ013}}
          今日賣出成交:{{stkmq.MQ014}}
        </div>
        }

        <div class="flex">
          <app-jkbuttongroup [styleDisplay]="'flex'" [placeholder]="'條件'" [items]="stktsSrv.ts011List"
            [(value)]="stktsSrv.ts011">
          </app-jkbuttongroup>
          <app-jkcheckboxYN label="暫存" [(valueYN)]="stktsSrv.newItem.TS020">
          </app-jkcheckboxYN>

        </div>
        <app-jkcheckboxYN label="當沖" [disabled]="true" [(valueYN)]="stktsSrv.ts014YN">
        </app-jkcheckboxYN>
        <button type="button" class="btn w-full" [class.btn-primary]="true"
          [class.btn-primary-red]="stktsSrv.buysale === '0'"
          [class.btn-primary-green]="stktsSrv.buysale === '1'"
          (click)="doSend()">{{stktsSrv.buysaleTitle}}</button>
        <div class="flex">
          <button class="btn" (click)="doLoadRemember()">取前次</button>
        </div>
      </div>
    </mat-tab>
    <mat-tab #myDetailTab label="委託查詢">
      <div class="flex">
        <button class="btn" [class.btn-info]="true" (click)="doQuery()">查詢</button>
        <button class="btn" [class.btn-primary]="true" (click)="doChangePrice()">改價</button>
        <button class="btn" [class.btn-warning]="true" (click)="doChangeQty()">改量</button>
        <button class="btn" [class.btn-danger]="true" (click)="doDelete()">刪單</button>
      </div>
      <mat-divider></mat-divider>
      <div style="height: 400px;">
        <app-jkgridwin #jkgridwin (afterGridReady)="afterGridReady($event) ">
        </app-jkgridwin>
      </div>
    </mat-tab>
    <mat-tab #myDetailTab label="回報查詢">
      <app-jkdatefield label="回報日期" [(value)]="date" [showClearButton]="true" (valueChange)="onDateValueChange($event)">
      </app-jkdatefield>
      <div class="flex">
        <button class="btn" [class.btn-info]="true" (click)="doQueryReply()">回報查詢</button>
        <button class="btn" [class.btn-primary]="true" (click)="doComfirm()">
          <mat-icon fontIcon="check_circle"></mat-icon>過帳
        </button>
      </div>
      <mat-divider></mat-divider>
      <div style="height: 400px;">
        <app-jkgridwin (afterGridReady)="afterGridReadyReply($event) ">
        </app-jkgridwin>
      </div>
    </mat-tab>
    <mat-tab #myQuote label="未實現庫存">
      <div class="flex">
        <button class="btn" [class.btn-info]="true" (click)="doQuerybalanceGrid(1)">庫存明細查詢</button>
        <button class="btn" [class.btn-info]="true" (click)="doQuerybalanceGrid(3)">庫存彙總查詢</button>
        <button class="btn" [class.btn-info]="true" (click)="doQuerybalanceGrid(2)">即時證券庫存查詢</button>
        <button class="btn" [class.btn-info]="true" (click)="doBalanceGrid2Order()">轉下單</button>
      </div>
      <app-jkgridwin #stkmqGrid (afterGridReady)="afterGridReadyBalance($event)" (doubleClick)="balanceGridDoubleClick($event)">
      </app-jkgridwin>
    </mat-tab>

  </mat-tab-group>
</div>
